import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import PagesHeader from '../../../../components/base/PagesHeader';
import BaseSelectBox from '../../../../components/base/BaseSelectBox';
import useLocale from '../../../../hooks/useLocale';
import { FormProps, IntegrationSystemOptionLabelValue } from '../types';
import { getCompanyClientIntegration } from '../../../../api/service/superAdmin/company-clients/service';


const Integration: React.FC<FormProps> = ({ context }) => {
  const { localize } = useLocale();
  const { formGroup, updateIntegration } = context;
  const [systemIntegrationOptions, setSystemIntegrationOptions] = useState<{
    salarySystem: IntegrationSystemOptionLabelValue[];
    accountingSystem: IntegrationSystemOptionLabelValue[];
    hrSystem: IntegrationSystemOptionLabelValue[];
  }>({
    salarySystem: [],
    accountingSystem: [],
    hrSystem: []
  });
  
  useEffect(() => {
    const fetchIntegrationOptions = async () => {
      try {
        
        const integrationData = await getCompanyClientIntegration();
        if (integrationData) {
          setSystemIntegrationOptions({
            salarySystem: integrationData.salary_system.map((item: any) => ({
              label: item.label,
              value: item.id,
              label_sv: item.label_sv,
              label_en: item.label_en
            })) || [],
            accountingSystem: integrationData.accounting_system.map((item: any) => ({
              label: item.label,
              value: item.id,
              label_sv: item.label_sv,
              label_en: item.label_en
            })) || [],
            hrSystem: integrationData.hr_system.map((item: any) => ({
              label: item.label,
              value: item.id,
              label_sv: item.label_sv,
              label_en: item.label_en
            })) || []
          });
        }
      } catch (error) {
        console.error('Error fetching integration options:', error);
      }
    };
    
    fetchIntegrationOptions();
  }, []);

  return (
    <div>
      <PagesHeader pageTitle={localize('COMPANY.integration')} headingClass="fs-h3 font-black" translate={false} />
      <div className="form-section mb-3 dark-content-section">
        <div className="cr-form-row">
          <div>
            <Form.Label className="fs-name mb-0">{localize('COMPANY.integration_salary_system')}</Form.Label>
            <BaseSelectBox
              options={systemIntegrationOptions.salarySystem}
              noSelect
              name="integration.salarySystem"
              value={formGroup.values.integration?.salarySystem ?? ''}
              onChangeHandler={(e) => updateIntegration('salarySystem', e.target.value)}
              field={formGroup.getFieldMeta('integration.salarySystem')}
              placeholder={localize('select_salary_system') || 'Select salary system'}
              controlStyle={{ width: '180px' }}
              className='form-select--ellipsis'
            />
          </div>

          <div>
            <Form.Label className="fs-name mb-0">{localize('COMPANY.integration_accounting_system')}</Form.Label>
            <BaseSelectBox
              options={systemIntegrationOptions.accountingSystem}
              noSelect
              name="integration.accountingSystem"
              value={formGroup.values.integration?.accountingSystem ?? ''}
              onChangeHandler={(e) => updateIntegration('accountingSystem', e.target.value)}
              field={formGroup.getFieldMeta('integration.accountingSystem')}
              placeholder={localize('select_accounting_system') || 'Select accounting system'}
              controlStyle={{ width: '180px' }}
              className='form-select--ellipsis'
            />
          </div>

          <div>
            <Form.Label className="fs-name mb-0">{localize('COMPANY.integration_hr_system')}</Form.Label>
            <BaseSelectBox
              options={systemIntegrationOptions.hrSystem}
              noSelect
              name="integration.hrSystem"
              value={formGroup.values.integration?.hrSystem ?? ''}
              onChangeHandler={(e) => updateIntegration('hrSystem', e.target.value)}
              field={formGroup.getFieldMeta('integration.hrSystem')}
              placeholder={localize('select_hr_system') || 'Select HR system'}
              controlStyle={{ width: '180px' }}
              className='form-select--ellipsis'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Integration;
